import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const HighlyCitedIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.4543 5.51587H18.3575V12.4191L14.9059 16.3064V12.4191H11.4543V5.51587Z"
        fill="var(--cdl-accent-bg-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6451 5.51583C10.6451 5.06894 11.0074 4.70667 11.4543 4.70667H18.3575C18.8044 4.70667 19.1667 5.06894 19.1667 5.51583V12.419C19.1667 12.6171 19.0941 12.8082 18.9626 12.9563L15.511 16.8436C15.2879 17.0949 14.9327 17.1821 14.6185 17.0628C14.3044 16.9435 14.0967 16.6424 14.0967 16.3064V13.2282H11.4543C11.0074 13.2282 10.6451 12.8659 10.6451 12.419V5.51583ZM12.2634 6.32499V11.6099H14.9059C15.3528 11.6099 15.7151 11.9722 15.7151 12.419V14.1764L17.5483 12.1117V6.32499H12.2634Z"
        fill="var(--cdl-accent-bg-base)"
      />
      <path
        d="M11.4543 4.14258H18.3575V11.0458L14.9059 14.9331V11.0458H11.4543V4.14258Z"
        fill="var(--cdl-accent-bg-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6451 4.14253C10.6451 3.69565 11.0074 3.33337 11.4543 3.33337H18.3575C18.8044 3.33337 19.1666 3.69565 19.1666 4.14253V11.0458C19.1666 11.2438 19.094 11.4349 18.9626 11.583L15.5109 15.4703C15.2878 15.7216 14.9326 15.8088 14.6185 15.6895C14.3044 15.5702 14.0967 15.2691 14.0967 14.9331V11.8549H11.4543C11.0074 11.8549 10.6451 11.4926 10.6451 11.0458V4.14253ZM12.2634 4.9517V10.2366H14.9059C15.3528 10.2366 15.715 10.5989 15.715 11.0458V12.8031L17.5483 10.7384V4.9517H12.2634Z"
        fill="var(--cdl-accent-bg-base)"
      />
      <path
        d="M1.64253 5.51587H8.54575V12.4191L5.09414 16.3064V12.4191H1.64253V5.51587Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.83337 5.51583C0.83337 5.06894 1.19564 4.70667 1.64253 4.70667H8.54575C8.99264 4.70667 9.35491 5.06894 9.35491 5.51583V12.419C9.35491 12.6171 9.2823 12.8082 9.15082 12.9563L5.69921 16.8436C5.4761 17.0949 5.12091 17.1821 4.80679 17.0628C4.49266 16.9435 4.28498 16.6424 4.28498 16.3064V13.2282H1.64253C1.19564 13.2282 0.83337 12.8659 0.83337 12.419V5.51583ZM2.45169 6.32499V11.6099H5.09414C5.54103 11.6099 5.9033 11.9722 5.9033 12.419V14.1764L7.73659 12.1117V6.32499H2.45169Z"
        fill="currentColor"
      />
      <path
        d="M1.64249 4.14258H8.54572V11.0458L5.0941 14.9331V11.0458H1.64249V4.14258Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833334 4.14253C0.833334 3.69565 1.19561 3.33337 1.64249 3.33337H8.54572C8.9926 3.33337 9.35488 3.69565 9.35488 4.14253V11.0458C9.35488 11.2438 9.28226 11.4349 9.15078 11.583L5.69917 15.4703C5.47606 15.7216 5.12088 15.8088 4.80675 15.6895C4.49263 15.5702 4.28494 15.2691 4.28494 14.9331V11.8549H1.64249C1.19561 11.8549 0.833334 11.4926 0.833334 11.0458V4.14253ZM2.45166 4.9517V10.2366H5.09411C5.54099 10.2366 5.90327 10.5989 5.90327 11.0458V12.8031L7.73655 10.7384V4.9517H2.45166Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HighlyCitedIcon;
